import { FC, ReactNode } from 'react';

import { Box, forwardRef, StyleProps, TabProps, useTab } from '@bonusly/design-system';

interface HighlightTabProps extends TabProps {
	children: ReactNode;
}

const getStyle = (isSelected?: boolean): StyleProps => ({
	borderBottomColor: 'rgba(0, 0, 0, 0)',
	borderBottomWidth: '4px',
	color: 'gray.500',
	fontSize: 'md',
	fontWeight: 'medium',
	pb: 2.5,
	pt: 3.5,
	px: 3,
	...(isSelected && {
		color: 'blue.600',
		borderBottomColor: 'blue.600',
	}),
});

export const HighlightTab: FC<HighlightTabProps> = forwardRef(({ children, ...props }, ref) => {
	const tabProps = useTab({ ...props, ref });
	const isSelected = !!tabProps['aria-selected'];

	return (
		<Box as="button" {...getStyle(isSelected)} {...tabProps}>
			{children}
		</Box>
	);
});
